import {BrandID} from "../../enums/brand-id";
import {Organization} from "../organization";
import {ProjectProductType} from "../../enums/project-product-type";

export class OrgunitXProjectProductType {

  organization!: Organization;
  brandID!: BrandID;
  projectProductType!: ProjectProductType;


}
